import { render, staticRenderFns } from "./EventCompany.vue?vue&type=template&id=5b4cd9a7&scoped=true"
import script from "./EventCompany.vue?vue&type=script&lang=ts"
export * from "./EventCompany.vue?vue&type=script&lang=ts"
import style0 from "./EventCompany.vue?vue&type=style&index=0&id=5b4cd9a7&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4cd9a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b4cd9a7')) {
      api.createRecord('5b4cd9a7', component.options)
    } else {
      api.reload('5b4cd9a7', component.options)
    }
    module.hot.accept("./EventCompany.vue?vue&type=template&id=5b4cd9a7&scoped=true", function () {
      api.rerender('5b4cd9a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/EventCompany.vue"
export default component.exports